import axios from 'axios'
import { i18n } from 'src/boot/i18n'
import { trackIssueCustom } from 'src/boot/sentry'
import { cacheAdapterEnhancer, throttleAdapterEnhancer } from 'axios-extensions'
import LRUCache from 'lru-cache'

const API_URL = process.env.API_URL

// CACHE config
const TWO_MINUTES = 1000 * 60 * 2
const CAPACITY = 100

const defaultAdapter = axios.getAdapter(axios.defaults.adapter)

// enhance the original axios adapter with throttle and cache enhancer
const api = axios.create({
  baseURL: API_URL,
  // headers: { 'Cache-Control': 'no-cache' },
  adapter: throttleAdapterEnhancer(
    cacheAdapterEnhancer(
      defaultAdapter,
      { enabledByDefault: true, defaultCache: new LRUCache({ maxAge: TWO_MINUTES, max: CAPACITY }) }
    )
  )
})

export default async ({ app, router, store, Vue }) => {
  api.interceptors.request.use(
    config => {
      if (store.state.auth.token) {
        config.headers['Authorization'] = store.state.auth.token
      } else if (store.state.auth.accessToken) {
        config.headers['Authorization'] = store.state.auth.accessToken
      } else {
        if (!config.headers['Authorization']) {
          config.headers['Authorization'] = 'anonymous'
        }
      }
      return config
    },
    error => {
      return Promise.reject(error)
    }
  )

  api.interceptors.response.use(
    response => {
      return response
    },
    error => {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        const { response: { status, data } } = error
        if (status === 403 && data.message.indexOf('with an explicit deny') + 1) {
          store.dispatch('auth/resetToken')
        } else if (status === 401 && data.message.indexOf('Unauthorized') + 1) {
          store.dispatch('auth/resetToken')
        } else if (
          data.error &&
          (data.error.indexOf('no such user with e-mail') + 1) &&
          (data.error.indexOf('dynamo: no item found') + 1)
        ) {
          error.response.data.error = i18n.t('errors.unknownEmail')
        }

        // SENTRY DEBUG
        if (data.error && (data.error.indexOf('no such user with e-mail') + 1)) {
          trackIssueCustom({
            section: 'Generic API',
            title: 'Generic API: global CATCH: no such user with e-mail',
            data: error.response
          })
        }
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js

        // DEBUG stuff
        // trackIssueCustom({
        //   section: 'Generic API',
        //   title: 'Generic API: response interceptor CATCH: no response was received',
        //   tags: {
        //     // returnedData: 'error.request'
        //     returnedData: 'error Object'
        //   },
        //   // data: error.request
        //   data: {
        //     code: error.code,
        //     isAxiosError: error.isAxiosError,
        //     request: error.request,
        //     message: error.message
        //   }
        // })
      } else {
        // Something happened in setting up the request that triggered an Error

        // DEBUG stuff
        trackIssueCustom({
          section: 'Generic API',
          title: 'Generic API: response interceptor CATCH: Something happened in setting up the request that triggered an Error',
          tags: {
            returnedData: 'error.message'
          },
          data: error.message
        })
      }

      return Promise.reject(error)
    }
  )

  api.defaults.headers.post['Content-Type'] = 'application/json'

  Vue.prototype.$api = api
}

export { api, axios }
